module.exports = __webpack_public_path__ + "static/media/img.user.fac9be08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/AppStore/AppManage/AppBatchSetPower/UI.SetPower/Icon/img.user.svg
// module id = 1068
// module chunks = 0